// <manual />
// Extensão manual para ESTQ_TIPO_LOCAL_ESTOCAGEM.
// Não edite o arquivo principal (ESTQ_TIPO_LOCAL_ESTOCAGEM.js) — ele é auto-gerado
// pelo SetupController e será sobrescrito.
//
// Classifica o tipo de local de estocagem em duas naturezas de gestão:
//   • Estoque de Trânsito → custos gerenciados via RateioCustosComex
//                           e saldos detalhados em SaldoEstoqueOrigem.
//   • Estoque Final       → saldos em SaldoEstoque e movimentos em MovimentacaoEstoque.

import { ESTQ_TIPO_LOCAL_ESTOCAGEM } from '@/constants/ESTQ_TIPO_LOCAL_ESTOCAGEM'

const CodigosEstoqueTransito = [
  ESTQ_TIPO_LOCAL_ESTOCAGEM.PreEmbarque,
  ESTQ_TIPO_LOCAL_ESTOCAGEM.Transito,
  ESTQ_TIPO_LOCAL_ESTOCAGEM.AlfandegadoOuEntreposto
]

const CodigosEstoqueFinal = [
  ESTQ_TIPO_LOCAL_ESTOCAGEM.ProprioInterno,
  ESTQ_TIPO_LOCAL_ESTOCAGEM.TerceirosArmazemGeral
]

export const ESTQ_TIPO_LOCAL_ESTOCAGEM_CUSTOM = {
  /** Locais onde o material ainda está em processo de importação. */
  CodigosEstoqueTransito,

  /** Locais onde o material já está consolidado no estoque final. */
  CodigosEstoqueFinal,

  /**
   * Retorna true se o tipo de local é um estoque de trânsito.
   * @param {string|null|undefined} tipoLocal - Valor de LstTipoLocal
   * @returns {boolean}
   */
  ehEstoqueTransito: (tipoLocal) => CodigosEstoqueTransito.includes(tipoLocal),

  /**
   * Retorna true se o tipo de local é um estoque final.
   * @param {string|null|undefined} tipoLocal - Valor de LstTipoLocal
   * @returns {boolean}
   */
  ehEstoqueFinal: (tipoLocal) => CodigosEstoqueFinal.includes(tipoLocal)
}
